import { canRead, canWrite } from '../access/rbacAccess'

export const PROMOTIONS = {
  LIST: 'planifica.promotions'
}

export const canViewPromotions = () => canRead(PROMOTIONS.LIST)

export const canManagePromotions = () => canWrite(PROMOTIONS.LIST)
